import Button from '@/components/Button';
import { useChapterStore } from '@/pages/mission/shared/store/useChapterStore';
import { useMissionStore } from '@/pages/mission/shared/store/useMissionStore';
import { useNavigate } from 'react-router-dom';

export const ReflectionVideos = () => {
  const navigate = useNavigate();
  const chapterPage = useChapterStore((state) => state.chapterPage);
  const mission = useMissionStore((state) => state.mission);

  const handleClick = () => {
    navigate(`/reflection-videos/${mission?.keyStage?.documentId}`);
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5 text-center">
      <h2 className="font-cadiz text-sh-lg font-bold">{chapterPage?.watchReflectionVideo?.title}</h2>
      <p className="font-cadiz text-sh-sm">{chapterPage?.watchReflectionVideo?.description}</p>
      <Button theme="solid-primary-600" onClick={handleClick}>
        {chapterPage?.watchReflectionVideo?.btnText}
      </Button>
    </div>
  );
};
